// Escopo "ver como" dentro de um espaco "PPS para Professores"
// (clubs.kind='professor'): o dono alterna entre "Todos" (visao unificada,
// agregado de todo o pool — comportamento padrao) e um professor especifico
// do pool (visao individual, mesmo recorte que aquele professor ve via RLS).
//
// Persistido em localStorage via chave `pps.professorScope.<userId>`
// (mesmo padrao de viewScope.ts). Diferente de ViewScope, nao ha "rede" aqui
// — so troca de professor dentro do MESMO clube, entao nao precisa do state
// machine de validacao contra uma lista de clubes; o ProfessorScopeSwitcher
// e responsavel por resetar para 'all' se o teacherId persistido nao existir
// mais no pool atual (club_teachers).
export type ProfessorScope =
  | { type: 'all' }
  | { type: 'teacher'; teacherId: string };

export const PROFESSOR_SCOPE_STORAGE_PREFIX = 'pps.professorScope.';

export function professorScopeStorageKey(userId: string): string {
  return `${PROFESSOR_SCOPE_STORAGE_PREFIX}${userId}`;
}

/** Type guard: valida payload lido do localStorage (nao confiavel). */
export function isProfessorScope(value: unknown): value is ProfessorScope {
  if (!value || typeof value !== 'object') return false;
  const v = value as Record<string, unknown>;
  if (v.type === 'all') return true;
  if (v.type === 'teacher') return typeof v.teacherId === 'string' && v.teacherId.length > 0;
  return false;
}
